import dev from './development';
import staging from './staging';

export interface IConfig {
  API: {
    ROOT_ENDPOINT: string;
    BACKOFFICE_ENDPOINT: string;
  };
  API_SESSIONS_PATH: {
    START_SESSION: string;
    END_SESSION: string;
    PING_SESSION: string;
    DELETE_SESSION: string;
    SESSIONS: string;
    SESSIONS_ACTIVE: string;
  };
  API_ACTIVITIES_PATH: {
    ACTIVITIES: string;
  };
  API_BACKOFFICE_PATH: {
    VERIFY_COURSE: string;
  };
}

let config: IConfig = { ...dev };
const env = process.env.NODE_ENV;
switch (env) {
  case 'development':
    config = dev;
    break;
  case 'test':
    config = staging;
    break;
  default:
    break;
}

export const defaultConfig = {
  // Add common config values here
  env,
  ...config,
};

export default defaultConfig;
